import ShowMoreContent from 'shared/show_more_content';

import $ from "jquery";
import CommentVideoSection from 'shared/components/comment_video_section';
import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';

export default class ShowMoreComments {
  init(containerSelector, commentsListSelector, linkContainerSelector) {
    let video = window.kmklabs.video;

    this.commentsListSelector = commentsListSelector;
    this.notEligibleToComment = (video && video.premium == "true" && video.source == false)
    $(document).on('click', containerSelector + ' ' + linkContainerSelector + ' :first-child', this.getMoreComments.bind(this));
  }

  get commentDisplayPerShow() {
    return 10;
  }

  getMoreComments(event) {
    event.preventDefault();
    let $target = $(event.target);
    let targetValue = {
      video_id: $target.data('video-id'),
      last_comment_id: $target.data('last-comment-id'),
      order: $target.data('order'),
      offset: $target.data('offset')
    }
    let params = this.generateParams(targetValue);

    $.get('/comments.html', params).always(function(data) {
      this.appendComments($target.parent(), data);

      if (this.notEligibleToComment) {
        CommentVideoSection.hideReplyButton();
      }
    }.bind(this));
  }

  generateParams(params) {
    let generated = Object.assign({}, params);

    if (generated.order) {
      generated["count"] = this.commentDisplayPerShow;
    } else {
      delete generated.order;
      delete generated.offset;
    }

    return generated;
  }

  appendComments($targetContainer, data) {
    let commentContainer = $targetContainer.siblings(this.commentsListSelector);

    commentContainer.append(data);
    let last_comment_id = this.getLastCommentId();

    let showMore = $targetContainer.find(':first-child');
    showMore.data('last-comment-id', last_comment_id);
    showMore.data('offset', parseInt(showMore.data('offset')) + 10);
    let totalComments = parseInt($(".video-comments-count").text());
    let totalCurrentComments = $(".comments__list-item").length;

    if (($(data).length < this.commentDisplayPerShow) || ((totalComments > 3) && (totalComments <= totalCurrentComments))) {
      $targetContainer.hide();
    }
    $("span.publish-date").timeago();
    new ShowMoreContent('.js-comment-container', '.truncate .read-more-comment', '.hidden'); // comment content
    new ComponentInitializers();
  }

  getLastCommentId() {
    return $(this.commentsListSelector).children()
      .map(function(_unused, element) {
        return $(element).data("id");
      })
      .sort().splice(0)[0];
  }
}
